export default {
  LOGIN_ENDPOINT: '/me?fields=email,name,picture',
  PERMISSION_SCOPE: 'public_profile,user_friends,user_actions.books, email',
  LOGIN_BUTTON_TEXT: 'sso_inicia_sesion_text',
  FACEBOOK_SCRIPT_SDK_SOURCE:
    'https://connect.facebook.net/es_LA/sdk.js#xfbml=1&version=v5.0&appId=407287369327882&autoLogAppEvents=1',
  FACEBOOK_SCRIPT_ID: 'fb-script',
  FACEBOOK_APP_ID: '407287369327882',
  FACEBOOK_SCRIPT_API_VERSION: 'v5.0',
};
